<template>
  <component :is="logo" v-if="logo" />
  <span
    v-else
    class="inline-flex items-center text-xl font-bold tracking-tight"
    >{{ label }}</span
  >
</template>

<script setup lang="ts">
import { computed, type Component } from "vue";
import BiogenaLogo from "./BiogenaLogo.vue";
import BioxLogo from "./BioxLogo.vue";
import NevoGroupLogo from "./NevoGroupLogo.vue";

const props = defineProps<{ name: string | null; label: string }>();
const logos: Record<string, Component> = {
  biogena: BiogenaLogo,
  biox: BioxLogo,
  nevo: NevoGroupLogo,
};
const logo = computed(() => (props.name ? logos[props.name] : undefined));
</script>
